export interface FeatureOption {
    label: string;
    icon: string;
}

export enum IconType {
    TICK = 'TICK',
    CROSS = 'CROSS',
}

export enum DecisionStages {
    START = '1',
    COMMITMENT = '2',
    DECISION = '3',
    POLL = '4',
    DONE = '5',
}

export type FormStorage = Record<
    string,
    {
        factFind: {
            loanDetails: any;
            applicants: any;
            incomings: any;
            propertyDetails: any;
            outgoings: any;
        };
        factFindForm: {
            loanDetails: any;
            applicants: any;
            incomings: any;
            propertyDetails: any;
            outgoings: any;
        };
    }
>;

export interface AddressValue {
    id?: string;
    addressType?: string | null;
    buildingNumber?: string;
    street?: string;
    buildingName?: string;
    postcode?: string;
    line1?: string;
    line2?: string;
    udprn?: string;
    uprn?: string;
    poBox?: string;
    city?: string;
    county?: string;
    country?: string;
    subBuildingName?: string | null;
    dependantThoroughfare?: string;
    streetNumber?: string;
    streetName?: string;
    departmentName?: string;
    organisationName?: string;
    isSaved?: boolean;
}
